<template>
<!-- width="38" height="38" viewBox="0 0 38 38" -->
  <rect width="38" height="38" rx="19" fill="#FFED00"/>
  <path d="M12.1573 14.8718C12.1345 14.7011 12.2673 14.5495 12.4395 14.5495H25.7823C25.9545 14.5495 26.0873 14.7011 26.0645 14.8718L24.0904 29.6774C24.0716 29.8188 23.9509 29.9245 23.8082 29.9245H14.4136C14.2709 29.9245 14.1502 29.8188 14.1313 29.6774L12.1573 14.8718Z" stroke="#233F1F" stroke-width="1.70833"/>
  <path d="M10 11.416H28.2222" stroke="#233F1F" stroke-width="1.70833"/>
  <path d="M19.1113 8L19.1113 11.4167" stroke="#233F1F" stroke-width="1.70833"/>
  <path d="M16.2635 17.1113L17.4023 27.3613" stroke="#233F1F" stroke-width="1.70833"/>
</template>
